import axios from "axios";
import { axiosInstance } from "./intreceptor";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});

class generateDescService {

  generateDescriptionAndTitle = (payload) => {
    return axiosInstance
      .post("/tag_generate/generateDescAndTitle",payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  }
  saveDescription = (payload) => {
    return axiosInstance
      .post("/tag_generate/updategeneratedescription",payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        throw err;
      });
  }

}

export default new generateDescService();
